import NorwegianIcon from 'shared/assets/no.svg?react';
import EnglishIcon from 'shared/assets/en.svg?react';
import SpanishIcon from 'shared/assets/es.svg?react';

export const langSelectIcons = {
  no: NorwegianIcon,
  en: EnglishIcon,
  es: SpanishIcon,
};
